interface IProps {
  canada_address: string[];
  usa_address: string[];
}

const OurLocation = ({ canada_address, usa_address }: IProps) => {
  return (
    <section id="location" className="w-full md:w-[90%] mx-auto py-6 mt-10">
      <div className="location1_content ">
        <div className="w-[90%] md:w-full mx-auto">
          <h2 className="text-[18px] text-[#131313] sm:text-2xl lg:text-4xl font-[600]">
            Where Are We Canada
          </h2>
          <p className="text-xs sm:text-sm lg:text-lg font-normal mt-5">
            5400 Robinson St, Niagara Falls, ON L2G 2A6
          </p>
        </div>

        <div id="location1_map" className="h-[300px] mt-5">
          <iframe
            title="Where are we Canada"
            src={`https://www.google.com/maps?q=${canada_address[0]}${canada_address[1]}${canada_address[2]}&output=embed`}
            width="100%"
            height="100%"
            style={{ border: '0' }}
            loading="lazy"
          />
        </div>
      </div>
      <div id="location2_content" className="mt-5">
        <div className="w-[90%] md:w-full mx-auto">
          <h2 className="text-[18px] text-[#131313] sm:text-2xl lg:text-4xl font-[600] mt-10">
            Where Are We USA
          </h2>
          <p className="text-xs sm:text-sm lg:text-lg font-normal mt-5">
            310 Pine Ave, Niagara Falls, NY 14301, United States
          </p>
        </div>
        <div id="location2_map" className="h-[300px] mt-3">
          <iframe
            title="Where are we USA"
            src={`https://www.google.com/maps?q=${usa_address[0]}${usa_address[1]}${usa_address[2]}&output=embed`}
            width="100%"
            height="100%"
            style={{ border: '0' }}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default OurLocation;
